<template>
  <div class="inline z-10">
    <span
      ref="tooltipIconElement"
      @mouseover="onHover"
      @click="toggleShow"
      @mouseleave="onExit"
      class="mr-2"
      ><font-awesome-icon :icon="['fas', 'info-circle']" color="#88888888"
    /></span>

    <div
      ref="tooltipBubble"
      v-show="showTooltip"
      class="border bg-gray-100 rounded-lg fixed px-2 py-1"
      :style="{
        width: `${tooltipWidth}px`,
        top,
        left,
        transform,
      }"
    >
      <slot>
        <p class="font-semibold" v-if="header">{{ header }}</p>
        <p v-if="body">{{ body }}</p>
      </slot>
    </div>
  </div>
</template>

<script>
const tooltipWidth = 256;
export default {
  name: "MoskitoTooltip",
  props: { header: String, body: String },
  data() {
    return {
      showTooltip: false,
      tooltipWidth,
      top: "",
      left: "",
      transform: "",
    };
  },
  methods: {
    toggleShow() {
      this.showTooltip = !this.showTooltip;
    },
    onHover(event) {
      if (this.showTooltip) {
        return;
      }
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const { clientX, clientY } = event;
      const popupRightOfIcon = clientX < windowWidth / 2;
      const popupBelowIcon = clientY < windowHeight / 2;
      this.showTooltip = true;

      let transform = "";

      this.left = `${clientX}px`;
      this.top = `${clientY}px`;

      if (popupRightOfIcon) {
        transform += "translateX(0)";
      } else {
        transform += "translateX(-100%)";
      }
      if (popupBelowIcon) {
        transform += " translateY(32px)";
      } else {
        transform += " translateY(calc(-100% - 32px))";
      }
      this.transform = transform;
    },
    onExit() {
      this.showTooltip = false;
    },
  },
};
</script>

<style scoped></style>
